const star = '*';

const getStatusForCount = (count, statusIntervals) => {
  let result = '';
  Object.keys(statusIntervals).forEach((status) => {
    if (statusIntervals[status] !== undefined) {
      const leftAsNumber = parseFloat(statusIntervals[status].split('-')[0]);
      const right = statusIntervals[status].split('-')[1];
      if (!isNaN(leftAsNumber)
        && leftAsNumber <= count
        && (right === star || count < parseFloat(right))) {
        result = status;
      }
    }
  });
  return result;
};

export default getStatusForCount;
